module.exports = __webpack_public_path__ + "a99fc54a087a1b4559be74a3d7cfdab8.svg";


//////////////////
// WEBPACK FOOTER
// ./images/raunch.svg
// module id = 472
// module chunks = 0